var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.65039 8.75H8.90839L9.90939 13.75H14.9544L15.6504 10.25H9.20839",
    stroke: "#64B5F6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4779 16.165C14.4973 16.1846 14.4972 16.2162 14.4777 16.2356C14.4581 16.2551 14.4265 16.255 14.407 16.2356C14.3875 16.2161 14.3875 16.1845 14.407 16.1649C14.4264 16.1454 14.458 16.1453 14.4776 16.1647L14.4779 16.165",
    stroke: "#64B5F6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4496 16.165C10.469 16.1846 10.4689 16.2162 10.4493 16.2356C10.4298 16.2551 10.3982 16.255 10.3787 16.2356C10.3592 16.2161 10.3592 16.1845 10.3786 16.1649C10.3981 16.1454 10.4297 16.1453 10.4493 16.1647L10.4496 16.165",
    stroke: "#64B5F6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.62847 17.1636C1.95054 13.3414 2.63856 8.10639 6.21315 5.106C9.78773 2.10562 15.0628 2.33547 18.3629 5.6354C21.6629 8.93533 21.893 14.2104 18.8927 17.7851C15.8925 21.3598 10.6575 22.048 6.83526 19.3703L3.99799 20.0007L4.62847 17.1636Z",
    stroke: "#64B5F6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.df0d74d89c76890bed9601b49b69f9bf.svg";
export { ForwardRef as ReactComponent };